import React from "react";
import "./Millennials.css";
import { images } from "../../assets";

function Millennials({ mTitle,mTitleMessage, mSubText, boxTitles, boxData, analyticsGirl,dailyActiveUsers,dailyActiveUsersData, className }) {
  return (
    <div className="millennials">
      <div className="millennialsBox">
        <div className="mText">
          <div className="mTitle">
            <div className={className.firstTitle}>{mTitle}</div>
            <div className="mTitleMessage">{mTitleMessage}</div>
          </div>
          <div className="mSubText">{mSubText}</div>
        </div>
        <div className="mContainer">
          <div className="box" id="box-1">
            <div className="box1Data">
              <div className="boxTitle titleTotalUsers">{boxTitles[0]}</div>
              <div className={`${className.boxStats} totalUserCommunity`}>{boxData[0]}</div>
            </div>
            <img src={images.totalUserMap} alt="map" />
          </div>
          <div className="box" id="box-2">
            <div className="csrData">
              <div className="box2Data">
                <div className="boxTitle">{boxTitles[1]}</div>
                <div className={className.boxStats}>{boxData[1]}</div>
              </div>
              <div className="box2Data">
                <div className="boxTitle">{dailyActiveUsers}</div>
                <div className={className.boxStats}>{dailyActiveUsersData}</div>
              </div>
            </div>
            <img className={className.analyticsGirl} src={analyticsGirl} alt="girl" />
          </div>
          {boxTitles.slice(2).map((title, index) => (
            <div className="box" key={`box-${index + 3}`} id={`box-${index + 3}`}>
              <div>
                <div className="boxTitle">{title}</div>
                <div className={className.boxStats}>{boxData[index + 2]}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Millennials;
